{
  "name": "core",
  "ramps": {
    "ink": [
      "#120E1C",
      "#271F38"
    ],
    "paper": [
      "#F4F0E4"
    ],
    "bub": [
      "#1F5C2A",
      "#2F8F3A",
      "#5CC24A",
      "#9BE36A"
    ],
    "bob": [
      "#1E3A7A",
      "#2F5FC0",
      "#5A8FF0",
      "#9CC4FF"
    ],
    "belly": [
      "#C9A55A",
      "#F2D98C",
      "#FFF4C8"
    ],
    "spine": [
      "#B8B0A0",
      "#F2EEE2"
    ],
    "mouth": [
      "#8E2A3A",
      "#E0607A"
    ],
    "eye": [
      "#120E1C",
      "#FFFFFF"
    ],
    "bubbleBub": [
      "#2E9E4A",
      "#7FE08A",
      "#D4FFD8"
    ],
    "bubbleBob": [
      "#2F6FD0",
      "#86B8FF",
      "#DCEBFF"
    ],
    "bubbleWarn": [
      "#C8561E",
      "#F2A33A",
      "#FFE08A"
    ],
    "bubbleLate": [
      "#A3182E",
      "#E8445A",
      "#FFB0B8"
    ],
    "fire": [
      "#B5311A",
      "#F2701D",
      "#FFC23D",
      "#FFF4C2"
    ],
    "water": [
      "#1E4A9A",
      "#3F8FE0",
      "#9FD8FF"
    ],
    "bolt": [
      "#C9A800",
      "#FFE84A",
      "#FFFBD0"
    ],
    "metal": [
      "#3B3F4A",
      "#6B7280",
      "#A9B0BC"
    ],
    "gold": [
      "#8A5A12",
      "#D9A021",
      "#FFE27A"
    ],
    "hudAccent": [
      "#FFB000"
    ],
    "angry": [
      "#8A0030",
      "#D0104A",
      "#FF3A6A",
      "#FF9AB8"
    ],
    "zen": [
      "#5A5A98",
      "#8C8CBD",
      "#ADADDE",
      "#E4E4FA"
    ],
    "robe": [
      "#8A8AA8",
      "#C8C8DC",
      "#F4F4FF",
      "#FFFFFF"
    ],
    "monsta": [
      "#40007A",
      "#6A00C8",
      "#8C00FF",
      "#C68CFF"
    ],
    "pulpul": [
      "#C86A7A",
      "#F29A9A",
      "#FFBDBD",
      "#FFE4E4"
    ],
    "banebou": [
      "#A04A00",
      "#E07000",
      "#FF8C00",
      "#FFC070"
    ],
    "hidegons": [
      "#6A6A98",
      "#9A9AC8",
      "#BDBDE6",
      "#E8E8FA"
    ],
    "invader": [
      "#6A6A98",
      "#9A9AC8",
      "#B6B6E4",
      "#E4E4FA"
    ],
    "drunk": [
      "#005A00",
      "#008A00",
      "#00AD00",
      "#5AE05A"
    ],
    "bottle": [
      "#1A5A2A",
      "#3A9A4A",
      "#9AE0A0"
    ],
    "skel": [
      "#6E6E8A",
      "#B8B8D0",
      "#EDEDF6",
      "#FFFFFF"
    ],
    "bubTrim": [
      "#C99A10",
      "#FFD83A",
      "#FFF09A"
    ],
    "bobTrim": [
      "#4A8FD0",
      "#8FC8FF",
      "#D0E8FF"
    ],
    "limb": [
      "#9A1E5E",
      "#E0449A",
      "#FF8CC8"
    ],
    "bubble": [
      "#1E8A3A",
      "#3CC45A",
      "#9BF0A8",
      "#E4FFE8"
    ],
    "windKey": [
      "#5A00B0",
      "#8C00FF",
      "#009CFF",
      "#80D8FF"
    ],
    "hotFeet": [
      "#A0004A",
      "#FF0073",
      "#FF6AAE"
    ],
    "shoe": [
      "#0060B0",
      "#009CFF",
      "#80D0FF"
    ],
    "antenna": [
      "#0090B0",
      "#00E0FF",
      "#A0F4FF"
    ],
    "face": [
      "#C8A078",
      "#F0C8A0",
      "#FFE4C8"
    ],
    "cheek": [
      "#C83A6A",
      "#FF6A9A",
      "#FFA8C8"
    ],
    "rock": [
      "#4A4046",
      "#7A6E72",
      "#ABA0A0"
    ],
    "leaf": [
      "#1E6A24",
      "#34A03A",
      "#7AD65A"
    ],
    "berry": [
      "#8A0A1E",
      "#E0243A",
      "#FF7A84"
    ],
    "melon": [
      "#1A5A1E",
      "#3C9A34",
      "#8ED86A"
    ]
  }
}
